import { ShieldCheck, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { useAzure } from "@/context/AzureContext";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

const STATE_STYLE = {
  disabled: "bg-muted text-muted-foreground",
  enabled: "bg-amber-100 text-amber-700",
  enforced: "bg-emerald-100 text-emerald-700",
};

export default function Mfa() {
  const { state, run, refresh } = useAzure();
  const users = state?.entra_users || [];

  const change = (u, v) =>
    run(() => api.post("/azure/identity/mfa", { user_id: u.object_id, state: v }), { success: `MFA ${v} for ${u.display_name}` });

  return (
    <div data-testid="az-mfa">
      <div className="flex items-center gap-2 border-b border-border pb-3 mb-3">
        <Button size="sm" variant="ghost" onClick={refresh} className="gap-2"><RefreshCw className="h-4 w-4" /> Refresh</Button>
        <span className="text-xs text-muted-foreground ml-auto">Per-user MFA — Disabled, Enabled (user registers on next sign-in) or Enforced.</span>
      </div>
      <div className="border border-border rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow><TableHead>User</TableHead><TableHead>UPN</TableHead><TableHead>Registered</TableHead><TableHead>Methods</TableHead><TableHead className="w-48">MFA state</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {users.map((u) => {
              const mfa = u.mfa || { state: "disabled", registered: false, methods: [] };
              return (
                <TableRow key={u.object_id} data-testid={`az-mfa-row-${u.mail_nickname}`}>
                  <TableCell className="font-medium">{u.display_name}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{u.upn}</TableCell>
                  <TableCell><Badge variant="outline" className="text-xs">{mfa.registered ? "Yes" : "No"}</Badge></TableCell>
                  <TableCell className="text-xs text-muted-foreground">{(mfa.methods || []).join(", ") || "—"}</TableCell>
                  <TableCell>
                    <Select value={mfa.state} onValueChange={(v) => change(u, v)}>
                      <SelectTrigger data-testid={`az-mfa-select-${u.mail_nickname}`} className={`h-8 text-xs ${STATE_STYLE[mfa.state] || ""}`}>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        {(state?.identity_catalog?.mfa_states || ["disabled", "enabled", "enforced"]).map((s) => (
                          <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
